import SectionHeading from "@/components/base/SectionHeading";
import ScoopCard from "@/components/feature/ScoopCard";
import { scoops } from "@/mocks/scoops";

export default function LatestScoops() {
  const [featured, ...rest] = scoops;
  const grid = rest.slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="最新爆料"
        title="刚刚通过核实的线索"
        desc="每条爆料都标注了核实状态与信息来源范围。状态为「核实中」的条目仍在补充佐证，我们会在有进展时更新页面。"
        action={{ label: "进入爆料库", to: "/scoops" }}
      />

      <div className="mt-8">
        <ScoopCard scoop={featured} variant="featured" />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {grid.map((scoop) => (
          <ScoopCard key={scoop.id} scoop={scoop} />
        ))}
      </div>
    </section>
  );
}